var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.requestType === 'download')?_c('btn',{attrs:{"label":_vm.useLabel},on:{"click":_vm.getTokenAndDownloadReport}}):(_vm.requestType === 'email')?_c('btn',{attrs:{"label":_vm.useLabel},on:{"click":_vm.emailReport}}):(_vm.requestType === 'print')?_c('btn',{attrs:{"label":_vm.useLabel},on:{"click":_vm.getTokenAndPrintReport}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }